/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import { PROPS_LIST } from '../../constants/props';
import styles from './index.styl';

const defaultClassName = 'bsw2-1';
const Drawer = ({
  children,
  className,
  opened,
  position,
  scrollable,
  style,
  width,
  zIndex,
}) => (
  <aside
    {...{ children }}
    className={classNames(defaultClassName, className)}
    styleName={classNames('root', {
      [`root--${position}`]: position,
      'root--closed': !opened,
      'root--fixed': !scrollable,
    })}
    style={Object.assign({}, { width, zIndex }, style)}
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    tabIndex="0"
  />
);

Drawer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.number,
    PropTypes.string,
  ]),
  className: PropTypes.string,
  opened: PropTypes.bool,
  position: PropTypes.oneOf(PROPS_LIST.drawer.position),
  scrollable: PropTypes.bool,
  style: PropTypes.object,
  width: PropTypes.number,
  zIndex: PropTypes.number,
};

Drawer.defaultProps = {
  opened: true,
  position: 'left',
  scrollable: true,
  width: 300,
  zIndex: 1,
};

export default CSSModules(Drawer, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Drawer/index.jsx